<template>
  <section class="wrap">
    <el-form ref="form" :model="form" :rules='rules' label-width="200px" size="small">
      <el-card class="base-info">
        <p class="title">基本信息</p>
        <el-form-item label="卡种名称：" prop="name">
          <el-input placeholder="请输入卡种名称" v-model.trim="form.name" class="width_short" maxlength="10"></el-input>
          <span class="label-tip">10个字以内</span>
        </el-form-item>
        <el-form-item label="顶部主图：" prop='topPic'>
          <el-upload class="top-pic-uploader" accept=".gif,.png,.jpg" :action="commonUrl.uploadImg"
            :headers="commonUrl.headers" :data="mediaObj" :multiple="false" :before-upload="beforeUpload"
            :on-success="coverImgSuccess" :show-file-list="false" style="margin-top: 10px;">
            <img v-if="form.topPic" class="top-pic" :src="commonUrl.imgPrefix_qN + form.topPic">
            <i v-else class="iconfont icon-picture-add"></i>
          </el-upload>
          <span class="label-tip">尺寸为750px*280px；支持GIF、PNG、JPG格式，500kb以内</span>
        </el-form-item>
        <el-form-item label="按钮文字颜色：" prop="buttonTextColor">
          <el-input placeholder="请输入按钮文字颜色" v-model.trim="form.buttonTextColor" class="width_short"
            maxlength="6"></el-input>
          <span class="label-tip">输入6位RGB颜色编号例如：C280FF；VIP主页顶部按钮颜色</span>
        </el-form-item>
        <el-form-item label="背景色：" prop="backgroundColor">
          <el-input placeholder="请输入背景色" v-model.trim="form.backgroundColor" class="width_short" maxlength="6"></el-input>
          <span class="label-tip">输入6位RGB颜色编号例如：C280FF；VIP主页顶部背景色</span>
        </el-form-item>
        <el-form-item label="卡种类型：" prop="type">
          <el-select v-model="form.type" class="width_short" placeholder="请选择卡种类型">
            <el-option v-for="(item, index) in vipTypeList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学科主页VIP营销文案：" prop="subjectHomepageVipMarketing">
          <el-input placeholder="请输入学科主页VIP营销文案" v-model.trim="form.subjectHomepageVipMarketing" class="width_short"
            maxlength="12"></el-input>
          <span class="label-tip">
            12个字以内；展示在学科主页VIP入口副标题</span>
        </el-form-item>
        <el-form-item label="权重：" prop="weight">
          <!-- <el-input placeholder="请输入权重" v-model.number.trim="form.weight" class="width_short" maxlength="6"
            oninput="value=value.replace(/[^\d.]/g,'')"></el-input> -->
          <el-input-number v-model.number="form.weight" class="width_short" :min="0" :max="999999" placeholder="请输入权重"
            @change="val => form.weight = val || ''"></el-input-number>
          <span class="label-tip">6位数以内</span>
        </el-form-item>
      </el-card>
      <el-card class="subject-setting">
        <p class="title">权益设置</p>
        <el-form-item label="内容权益：" prop="disciplineList">
          <div class="subject-list">
            <div class="subject-item" v-for="item in columnBindSubject" :key="item.disciplineId">
              <div>
                <span class="name">{{ item.disciplineName }}</span>
                <el-switch v-model="item.status" :active-value="true" :inactive-value="false"
                  active-color="#13ce66"></el-switch>
              </div>
              <el-checkbox-group v-if="item.status" v-model="item.disciplineIds">
                <el-checkbox v-for="(course, index) in item.disciplineSubjectRelationList"
                  :label="course.disciplineSubjectRelationId" :key="index">{{
                    course.subjectName }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </el-card>
      <el-card class="function-subject">
        <p class="title">功能权益</p>
        <ul>
          <li>
            <div class="name">权益名称</div>
            <div class="setting">权益设置</div>
          </li>
          <li>
            <div class="name">下载课件</div>
            <el-form-item class="setting" label-width="0">
              <el-switch v-model="form.isDownloadCourseware" :active-value="true" :inactive-value="false"
                active-color="#13ce66" inactive-color="#ff4949"></el-switch>
              <span class="laebl-tip">是否允许下载课件</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">学习营提问</div>
            <el-form-item class="setting" label-width="0" prop="isCampAsk">
              <el-switch v-model="form.isCampAsk" :active-value="true" :inactive-value="false" active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
              <span class="laebl-tip">是否允许学习营提问</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">线下培训折扣</div>
            <el-form-item class="setting" label-width="0" prop="isOfflineTrainingDiscount">
              <el-switch v-model="form.isOfflineTrainingDiscount" :active-value="true" :inactive-value="false"
                active-color="#13ce66" inactive-color="#ff4949"></el-switch>
              <span class="laebl-tip">允许线下折扣</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">赠课</div>
            <el-form-item class="setting" label-width="0" prop="isGiftCourse">
              <el-switch v-model="form.isGiftCourse" :active-value="true" :inactive-value="false" active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
              <span class="laebl-tip">
                只限【允许VIP免费观看】的课程</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">直播优先级答疑</div>
            <el-form-item class="setting" label-width="0" prop="answerWeight">
              <span>设置权重</span>
              <el-input placeholder="请输入" v-model.trim.number="form.answerWeight" class="width_short" maxlength="8"
                oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
              <span class="laebl-tip">权重越高，排序越靠前</span>
            </el-form-item>
          </li>
          <li>
            <div class="name">1080P画质</div>
            <el-form-item class="setting" label-width="0" prop="is1080pQuality">
              <el-switch v-model="form.is1080pQuality" :active-value="true" :inactive-value="false" active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
              <span class="laebl-tip">只限赠送【允许VIP免费观看】的课程</span>
            </el-form-item>
          </li>
        </ul>
      </el-card>
      <el-form-item label-width="0" style="margin-top: 20px;margin-left: 60px;">
        <el-button size="small" @click="cloesPage">取消</el-button>
        <el-button type="primary" size="small" :disabled="vipTypeDisabled" @click="saveHandle">保存</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script scoped>
import { mapGetters } from 'vuex'
import pageRouter from '@/utils/pageRouter'
import commonApi from '@/api/common'
import requestApi from '@/api/operateManage/vipType'
export default {
  name: 'vipTypePage',
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      commonUrl: commonApi.commonUrl,
      vipTypeId: '',
      form: {
        status: false,
        name: '',
        topPic: '',
        buttonTextColor: '',
        backgroundColor: '',
        type: '',
        subjectHomepageVipMarketing: '',
        weight: 0,
        disciplineList: [{
          disciplineId: 0,
          status: 1,
          name: '产科',
          disciplineIds: ['手术实操', '手术实操1'],
          refIdList: [{
            name: '手术实操',
          }, {
            name: '手术实操1',
          }, {
            name: '手术实操2',
          }, {
            name: '手术实操3',
          }],
        }, {
          disciplineId: 1,
          status: 1,
          name: '妇产科',
          disciplineIds: ['手术实操', '手术实操1'],
          refIdList: [{
            name: '手术实操',
          }, {
            name: '手术实操1',
          }, {
            name: '手术实操2',
          }, {
            name: '手术实操3',
          }]
        }],
        isDownloadCourseware: false, // 是否允许下载课件
        isCampAsk: false, // 学习营提问
        isOfflineTrainingDiscount: false, // 线下培训折扣
        answerWeight: 0, // 直播优先级答疑
        isGiftCourse: false, // 是否赠课
        is1080pQuality: false, // 1080P画质
      },
      rules: {
        name: { required: true, message: '请输入卡种名称', trigger: 'blur' },
        topPic: { required: true, message: '请选择顶部主图', trigger: 'change' },
        buttonTextColor: { required: true, message: '请输入按钮文字颜色', trigger: 'blur' },
        backgroundColor: { required: true, message: '请输入背景色', trigger: 'blur' },
        type: { required: true, message: '请选择顶部主图', trigger: 'change' },
        subjectHomepageVipMarketing: { required: true, message: '请输入营销文案', trigger: 'blur' },
        weight: { required: true, message: '请输入权重', trigger: 'blur' },
        answerWeight: { required: true, message: '请输入权重', trigger: 'blur' }
      },
      deleteDialogVisible: false, // 删除弹框
      mediaObj: {
        mediaJson: JSON.stringify({
          appType: 3,
          type: 1,
          picContent: { suffix: "png" }
        })
      },
      vipTypeList: [{
        id: 1,
        name: '临床VIP'
      }, {
        id: 2,
        name: '超级VIP'
      }],
      columnBindSubject: [], // 关联权益
      vipTypeDisabled: false,
    }
  },
  computed: {
    ...mapGetters('tabs', {
      TABACTIVE: 'tabActive'
    })
  },
  activated() {
    this.vipTypeId = this.$route.params.id;
    this.getColumnBindSubject();
  },
  mounted() {
    this.getColumnBindSubject();
  },
  methods: {
    // 查询学科与栏目绑定
    getColumnBindSubject() {
      requestApi.columnBindSubject().then(res => {
        if (res.Success) {
          res.Data.forEach(item => {
            item.disciplineIds = [];
            item.status = 0;
          })
          this.columnBindSubject = res.Data;
          if (this.vipTypeId) {
            this.getVipTypeDetail();
          }
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    // 详情
    getVipTypeDetail() {
      requestApi.detail(this.vipTypeId).then(res => {
        if (res.Success) {
          // 显示栏目绑定关系
          this.columnBindSubject.forEach((item, index) => {
            res.Data.disciplineList.forEach(item1 => {
              if (item.disciplineId === item1.disciplineId) {
                item.disciplineIds = item1.refIdList;
                item.status = true;
              }
            })
          })
          this.form = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    // 限制格式和大小
    beforeUpload(file) {
      const limitType = ['image/png', 'image/gif', 'image/jpeg'];
      const limitSize = 500;
      if (!limitType.includes(file.type)) {
        this.$message.error('仅支持GIF、PNG、JPG格式');
        return false;
      }
      if (file.size / 1024 > limitSize) {
        this.$message.error('图片大小不能超过500kb');
        return false;
      }
    },
    // 上传成功
    coverImgSuccess(res) {
      res = this.$apiOldResDeal(res)
      if (res.Success) {
        this.form.topPic = res.Data.url;
      } else {
        this.$message.error(res.Msg)
      }
    },
    // 保存
    saveHandle() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 设置相关权益
          let refIdList = [];
          let isCheckedColumn = true;
          this.columnBindSubject.forEach(item => {
            // 打开权益学科后，判断是否选择学科
            if (item.disciplineIds.length === 0 && item.status) {
              isCheckedColumn = false;
            }
            // 录入选择的栏目id
            if (item.disciplineIds.length > 0 && item.status) {
              refIdList = refIdList.concat(item.disciplineIds);
            }
          })
          if (!isCheckedColumn) {
            this.$message.error('打开权益学科后，至少选择一个栏目');
            return;
          }
          this.form.disciplineSubjectRelationIdList = refIdList;
          this.vipTypeDisabled = true;
          requestApi.save(this.form).then(res => {
            this.vipTypeDisabled = false;
            if (res.Success) {
              if (this.PAGEKEY === 'vipTypeAdd') {
                this.$message.success('添加成功！');
              } else {
                this.$message.success('编辑成功！');
              }
              this.cloesPage();
            } else {
              this.$message.error(res.Msg);
            }
          })
        }
      })
    },
    cloesPage() {
      this.$store.dispatch("tabs/removeSpecifiedTab", this.PAGEKEY);
      this.$store.dispatch("tabs/toTargetTab", this.PAGEBACK);
    },
  }
}
</script>

<style type="text/less" lang="less" scoped>
.header {
  margin-bottom: 15px;
}

.noMar {
  margin: 0;
}

.label-tip {
  color: grey;
  margin: 0 10px;
  opacity: 0.8;
}


.top-pic {
  display: inline-block;
  width: 300px;
  height: 115px;
  object-fit: contain;
  box-shadow: 3px 3px 30px #eaeaea;
}


.icon-picture-add::before {
  font-size: 50px;
  color: #DCDFE6;
}

.subject-setting {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subject-list {
  .subject-item {
    margin: 20px 0;

    .name {
      display: inline-block;
      width: 100px;
    }
  }
}


.function-subject ul li {
  display: flex;
  align-items: center;
  list-style: none;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  width: 80%;

  &:first-child {
    background-color: #647998;
    color: #fff;
    font-weight: 700;
    height: 50px;
    line-height: 50px;

    .name {
      text-align: center;
    }

    .setting {
      justify-content: center;
    }
  }

  .name {
    width: 30%;
    text-align: center;
    border-left: 1px solid #8496bf;
    border-right: 1px solid #8496bf;
    border-bottom: 1px solid #8496bf;
  }

  .setting {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    padding: 0 15px;
    width: 70%;
    height: 100%;
    border-bottom: 1px solid #8496bf;
    border-right: 1px solid #8496bf;

    span {
      margin-left: 15px;

      &:first-child {
        margin-right: 15px;
        margin-left: 0;
      }
    }


    .width_short {
      min-width: 150px;
    }

    /deep/ .el-form-item__error {
      margin-left: 74px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/operateManage/vipType/components/vipTypePage.vue